.ux-iws-sticky-scroll-bar {
    top: 0;
    position: sticky;
    display: block;
    z-index: 2;

    &__track-container {
        width: 100%;
        height: 26px;
        padding: 8px;
        transition: all 0.2s ease-in-out;
    }

    &__track {
        height: 10px;
        border-radius: 5px;
        background: $color-scroll-bar;
        cursor: grab;
        display: block;
    }

    &.is-sticky {
        .ux-iws-sticky-scroll-bar__track-container {
            background: $color-white;
            box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
        }
    }
}
